import React, { useEffect, useState } from "react";
import TransferModal from "./TransferModal";
import axios from "axios";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { ExcelExportColumn } from "@progress/kendo-react-excel-export";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
import TransferList from "./TransferList";
import apiInstance from "../../../../Utils/api";
// const uri = 'https://backendcherryk.cherrykmyanmar.com:4000/api/'
//const uri = 'http://localhost:9000/api/';
export default function Transfer() {
  const token = localStorage.getItem("token");
  const url = "https://backendcherryk.cherrykmyanmar.com:4000/api/";
  const api = apiInstance;

  const [showFilterBC, setShowFilterBC] = useState(false);
  const [origin, setOrigin] = useState(true);
  const [transferList, setTransferList] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState(new Date());
  const [open, setOpen] = useState(false);
  const [bankList, setBankList] = useState([]);
  const [cashList, setCashList] = useState([]);
  const [searchLists, setSearchLists] = useState([]);
  const [showSearch, setShowSearch] = useState(false);
  const [showOrigin, setShowOrigin] = useState(true);
  const [isShow, setIsShow] = useState(false);
  const [relatedList, setRelatedList] = useState([]);
  const [accList, setAccList] = useState([]);
  const [bank, setBank] = useState([]);
  const [filterBankCashList, setFilterBankCashList] = useState([]);

  const [cash, setCash] = useState([]);
  const [status, setStatus] = useState("");
  //FIlter Bank Cash

  const paymentFilter = (event) => {
    setStatus(event);
    switch (event) {
      case "Bank": {
        handleBank();

        break;
      }
      case "Cash": {
        handleCash();

        break;
      }
      case "Other": {
        // handleOther();

        break;
      }
      default:
        return event;
    }
  };
  const handleBank = (event) => {
    // const bankArray = accList.filter(
    //   el => el.relatedHeader.name === 'Cash At Bank'
    // )
    setBank(accList.filter((el) => el.relatedHeader.name === "Cash At Bank"));
  };
  const handleCash = (event) => {
    // const cashArray = accList.filter(
    //   el => el.relatedHeader.name === 'Cash In Hand'
    // )
    setCash(accList.filter((el) => el.relatedHeader.name === "Cash In Hand"));
  };

  const filterBankCash = (id) => {
    console.log(id, "id");
    setFilterBankCashList(transferList.filter((el) => el.fromAcc?._id === id));
    // console.log(
    //   transferList.filter((el) => el.fromAcc?._id === id),
    //   "filB li"
    // );

    setShowOrigin(false);
    setShowSearch(false);
    setShowFilterBC(true);
  };

  const handleRelated = (val) => {
    setRelatedList(transferList.filter((el) => el._id === val));
    console.log(
      transferList.filter((el) => el._id === val),
      "res",
    );
    if (isShow) {
      document.getElementById("toggle" + val).removeAttribute("hidden");
    } else {
      document.getElementById("toggle" + val).setAttribute("hidden", "hidden");
    }
    setIsShow(!isShow);
  };

  const handleModalBox = (event) => {
    setOpen(true);
  };

  const filter = (event) => {
    //added to right date
    const nDate = new Date(endDate);
    nDate.setDate(nDate.getDate() + 1);
    setEndDate(nDate);

    //change date format from en-us to en-ca

    setSearchLists(
      transferList.filter(
        (el) =>
          el.date >= startDate &&
          el.date <= endDate.toISOString().split("T")[0],
      ),
    );
    setShowSearch(true);
    setShowOrigin(false);
    setShowFilterBC(false);
  };

  useEffect(() => {
    const getBankList = async () => {
      api
        .get("accounting-lists")
        .then((response) => {
          setAccList(response.data.list);
          // console.log('response', response.data.list)
          const filteredArray = response.data.list.filter(
            (obj) => obj.relatedHeader.name === "Cash At Bank",
          );
          setBankList(filteredArray);
        })
        .catch((error) => {
          Swal.fire({
            title: "Error",
            text: error.response.data.message,
            icon: "error",
            confirmButtonText: "CANCEL",
          });
        });
    };

    const getCashList = async () => {
      api
        .get("accounting-lists")
        .then((response) => {
          const filteredArray = response.data.list.filter(
            (obj) => obj.relatedHeader.name === "Cash In Hand",
          );
          // console.log(filteredArray, 'cash')
          setCashList(filteredArray);
        })
        .catch((error) => {
          Swal.fire({
            title: "Error",
            text: error.response.data.message,
            icon: "error",
            confirmButtonText: "CANCEL",
          });
        });
    };

    const getTransferList = async () => {
      api
        .get("transfers")
        .then((response) => {
          console.log(response.data.data, "tran list");
          setTransferList(response.data.data);
        })
        .catch((error) => {
          Swal.fire({
            title: "Error",
            text: error.response.data.message,
            icon: "error",
            confirmButtonText: "CANCEL",
          });
        });
    };

    getBankList();
    getCashList();
    getTransferList();
  }, []);

  const _export = React.useRef(null);
  const _export1 = React.useRef(null);
  const _export2 = React.useRef(null);
  const excelExport = () => {
    if (_export.current !== null) {
      console.log(_export.current.props.data, "excel");
      _export.current.props.data.map(function (element, index) {
        element.date = element.date?.split("T")[0];
        element.from = element.fromAcc;
        element.to = element.toAcc;
      });
      _export.current.save();
    }
  };

  const excelExport1 = () => {
    if (_export1.current !== null) {
      console.log(_export1.current.props.data, "excel");
      _export1.current.props.data.map(function (element, index) {
        element.date = element.date?.split("T")[0];
        element.from = element.fromAcc;
        element.to = element.toAcc;
      });
      _export1.current.save();
    }
  };
  const excelExport2 = () => {
    if (_export2.current !== null) {
      console.log(_export2.current.props.data, "excel");
      _export2.current.props.data.map(function (element, index) {
        element.date = element.date?.split("T")[0];
        element.from = element.fromAcc;
        element.to = element.toAcc;
      });
      _export2.current.save();
    }
  };
  return (
    <>

        <div className="content-wrapper">
          <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-12">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item active">Transfer List</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
          <div className="card ml-3">
            <div className="row flex justify-content-between">
              <div className="col-md-8">
                <div className="row px-3 py-2">
                  <div className="form-group col-md-2 ml-1">
                    <label>From</label>
                    <input
                      type="date"
                      name="from"
                      id="from"
                      className="form-control"
                      onChange={(e) => setStartDate(e.target.value)}
                    />
                  </div>
                  <div className="form-group col-md-2">
                    <label>To</label>
                    <input
                      type="date"
                      name="to"
                      id="to"
                      className="form-control"
                      onChange={(e) => setEndDate(e.target.value)}
                    />
                  </div>
                  <div className="form-group col-md-2">
                    <button
                      className="btn btn-primary "
                      style={{ marginTop: "36px", fontSize: "14px" }}
                      onClick={filter}
                    >
                      Filter
                    </button>
                  </div>
                  <div className="col-md-2" style={{ marginTop: "2.5em" }}>
                    <select
                      class="custom-select border-info"
                      name="account_type_id"
                      onChange={(e) => paymentFilter(e.target.value)}
                    >
                      <option hidden>Filter By</option>
                      <option value="Bank">Bank</option>
                      <option value="Cash">Cash</option>
                    </select>
                  </div>
                  <div
                    className="
 col-md-3"
                    style={{ marginTop: "2.5em" }}
                  >
                    <select
                      class="custom-select border-info"
                      name="account_type_id"
                      onChange={(e) => filterBankCash(e.target.value)}
                    >
                      <option>Choose Related</option>
                      {status == "Bank" &&
                        bank.map((option) => (
                          <option value={option._id}>{option.name}</option>
                        ))}
                      {status == "Cash" &&
                        cash.map((option) => (
                          <option value={option._id}>{option.name}</option>
                        ))}

                      {/* {accList.map(option => (
                  <option value={option._id}>{option.name}</option>
                ))} */}
                    </select>
                  </div>
                </div>
              </div>

              <div
                className="flex justify-content-end col-2"
                style={{ marginTop: "3.6em" }}
              >
                {showOrigin && (
                  <button
                    className="btn btn-sm btn-success"
                    onClick={excelExport}
                  >
                    Export
                  </button>
                )}
                {showSearch && (
                  <button
                    className="btn btn-sm btn-success"
                    onClick={excelExport1}
                  >
                    Export
                  </button>
                )}
                {showFilterBC && (
                  <button
                    className="btn btn-sm btn-success"
                    onClick={excelExport2}
                  >
                    Export
                  </button>
                )}
                &nbsp;
                <button
                  className="btn btn-sm btn-primary"
                  onClick={handleModalBox}
                >
                  Transfer
                </button>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div className="">
                  <div className="card-header">
                    <div className="row d-flex justify-content-between">
                      <div className="form-group col-md-2"></div>
                    </div>
                  </div>

                  {/* //ListAll */}
                  <ExcelExport data={transferList} ref={_export}>
                    <ExcelExportColumn
                      field=""
                      title="No"
                      locked={true}
                      width={30}
                    />
                    <ExcelExportColumn
                      field="date"
                      title="Date"
                      width={100}
                      headerCellOptions={{
                        textAlign: "center",
                      }}
                      CellOptions={{
                        textAlign: "center",
                      }}
                    />
                    <ExcelExportColumn
                      field="from.name"
                      title="From Account"
                      width={250}
                      headerCellOptions={{
                        textAlign: "center",
                      }}
                      CellOptions={{
                        textAlign: "center",
                      }}
                    />
                    <ExcelExportColumn
                      field="to.name"
                      title="To Account"
                      width={150}
                    />
                    <ExcelExportColumn
                      field="remark"
                      title="Remark"
                      width={150}
                    />
                    <ExcelExportColumn
                      field="amount"
                      title="Balance"
                      width={100}
                      className="text-center"
                    />
                  </ExcelExport>

                  {/* Search List */}
                  <ExcelExport data={searchLists} ref={_export1}>
                    <ExcelExportColumn
                      field=""
                      title="No"
                      locked={true}
                      width={30}
                    />
                    <ExcelExportColumn
                      field="date"
                      title="Date"
                      width={100}
                      headerCellOptions={{
                        textAlign: "center",
                      }}
                      CellOptions={{
                        textAlign: "center",
                      }}
                    />
                    <ExcelExportColumn
                      field="from.name"
                      title="From Account"
                      width={250}
                      headerCellOptions={{
                        textAlign: "center",
                      }}
                      CellOptions={{
                        textAlign: "center",
                      }}
                    />
                    <ExcelExportColumn
                      field="to.name"
                      title="To Account"
                      width={150}
                    />
                    <ExcelExportColumn
                      field="remark"
                      title="Remark"
                      width={150}
                    />
                    <ExcelExportColumn
                      field="amount"
                      title="Balance"
                      width={100}
                      className="text-center"
                    />
                  </ExcelExport>

                  {/* Bank/Cash Filter */}
                  <ExcelExport data={filterBankCashList} ref={_export2}>
                    <ExcelExportColumn
                      field=""
                      title="No"
                      locked={true}
                      width={30}
                    />
                    <ExcelExportColumn
                      field="date"
                      title="Date"
                      width={100}
                      headerCellOptions={{
                        textAlign: "center",
                      }}
                      CellOptions={{
                        textAlign: "center",
                      }}
                    />
                    <ExcelExportColumn
                      field="from.name"
                      title="From Account"
                      width={250}
                      headerCellOptions={{
                        textAlign: "center",
                      }}
                      CellOptions={{
                        textAlign: "center",
                      }}
                    />
                    <ExcelExportColumn
                      field="to.name"
                      title="To Account"
                      width={150}
                    />
                    <ExcelExportColumn
                      field="remark"
                      title="Remark"
                      width={150}
                    />
                    <ExcelExportColumn
                      field="amount"
                      title="Balance"
                      width={100}
                      className="text-center"
                    />
                  </ExcelExport>

                  <div className="card-body">
                    <table id="example1" className="table">
                      <thead className=" ok">
                        <tr>
                          <th>No</th>

                          <th>Date</th>

                          <th>From Acc</th>
                          {/* <th>Related Treatment</th> */}
                          <th>To Acc</th>
                          <th>Remark</th>

                          <th>Amount</th>
                          <th className="text-center">Action</th>
                        </tr>
                      </thead>
                      {showSearch && (
                        <>
                          {searchLists
                            .slice(0)
                            .reverse()
                            .map((e, i) => (
                              <tbody key={e._id}>
                                <tr>
                                  <td>{++i}</td>
                                  <td>{e.date ? e.date.split("T")[0] : ""}</td>

                                  <td>{e.fromAcc?.name}</td>
                                  <td>{e.toAcc?.name}</td>
                                  <td>{e.remark ? e.remark : ""}</td>
                                  <td>{e.amount ? e.amount : ""}</td>
                                  <td className="text-center">
                                    <button class="btn btn-primary btn-sm">
                                      View
                                    </button>
                                  </td>
                                </tr>

                                <tr
                                  className="bg-gradient-light"
                                  id={"toggle" + e._id}
                                  hidden
                                >
                                  <td colspan="12">
                                    <div>
                                      <div class="row">
                                        <div class="col-md-2">
                                          <label
                                            style={{ fontSize: "15px" }}
                                            class="text-dark"
                                          >
                                            No
                                          </label>
                                        </div>
                                        <div class="col-md-3">
                                          <label
                                            style={{ fontSize: "15px" }}
                                            class="text-dark"
                                          >
                                            Account
                                          </label>
                                        </div>
                                        <div class="col-md-2">
                                          <label
                                            style={{ fontSize: "15px" }}
                                            class="text-dark"
                                          >
                                            Type
                                          </label>
                                        </div>
                                        <div class="col-md-2">
                                          <label
                                            style={{ fontSize: "15px" }}
                                            class="text-dark"
                                          >
                                            Date
                                          </label>
                                        </div>
                                        <div class="col-md-2">
                                          <label
                                            style={{ fontSize: "15px" }}
                                            class="text-dark"
                                          >
                                            Amount
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            ))}
                        </>
                      )}

                      {showOrigin && (
                        <>
                          {transferList
                            .slice(0)
                            .reverse()
                            .map((e, i) => (
                              <tbody key={e._id}>
                                <tr>
                                  <td>{++i}</td>
                                  <td>{e.date ? e.date.split("T")[0] : ""}</td>

                                  <td>{e.fromAcc?.name}</td>
                                  <td>{e.toAcc?.name}</td>
                                  <td>{e.remark ? e.remark : ""}</td>
                                  <td>{e.amount ? e.amount : ""}</td>
                                  <td className="text-center">
                                    <button
                                      class="btn btn-primary btn-sm"
                                      onClick={() => handleRelated(e._id)}
                                    >
                                      View{" "}
                                    </button>
                                  </td>
                                </tr>

                                <tr
                                  className="bg-gradient-light"
                                  id={"toggle" + e._id}
                                  hidden
                                >
                                  <td colspan="12">
                                    <div>
                                      <div class="row">
                                        <div class="col-md-2">
                                          <label
                                            style={{ fontSize: "15px" }}
                                            class="text-dark"
                                          >
                                            No
                                          </label>
                                        </div>
                                        <div class="col-md-3">
                                          <label
                                            style={{ fontSize: "15px" }}
                                            class="text-dark"
                                          >
                                            Account
                                          </label>
                                        </div>
                                        <div class="col-md-2">
                                          <label
                                            style={{ fontSize: "15px" }}
                                            class="text-dark"
                                          >
                                            Type
                                          </label>
                                        </div>
                                        <div class="col-md-2">
                                          <label
                                            style={{ fontSize: "15px" }}
                                            class="text-dark"
                                          >
                                            Date
                                          </label>
                                        </div>
                                        <div class="col-md-2">
                                          <label
                                            style={{ fontSize: "15px" }}
                                            class="text-dark"
                                          >
                                            Amount
                                          </label>
                                        </div>
                                      </div>
                                      <div className="row">
                                        <div class="col-md-2">
                                          <span style={{ fontSize: "14px" }}>
                                            1
                                          </span>
                                        </div>
                                        <div class="col-md-3">
                                          <span style={{ fontSize: "14px" }}>
                                            {relatedList[0]?.fromAcc?.name}
                                          </span>
                                        </div>
                                        <div class="col-md-2">
                                          <span style={{ fontSize: "14px" }}>
                                            {
                                              relatedList[0]?.fromAcc
                                                ?.accountNature
                                            }
                                          </span>
                                        </div>
                                        <div class="col-md-2">
                                          <span style={{ fontSize: "14px" }}>
                                            {
                                              relatedList[0]?.date?.split(
                                                "T",
                                              )[0]
                                            }
                                          </span>
                                        </div>
                                        <div class="col-md-2">
                                          <span style={{ fontSize: "14px" }}>
                                            {relatedList[0]?.fromAcc?.amount}
                                          </span>
                                        </div>
                                      </div>
                                      <div className="row">
                                        <div class="col-md-2">
                                          <span style={{ fontSize: "14px" }}>
                                            2
                                          </span>
                                        </div>
                                        <div class="col-md-3">
                                          <span style={{ fontSize: "14px" }}>
                                            {relatedList[0]?.toAcc?.name}
                                          </span>
                                        </div>
                                        <div class="col-md-2">
                                          <span style={{ fontSize: "14px" }}>
                                            {
                                              relatedList[0]?.toAcc
                                                ?.accountNature
                                            }
                                          </span>
                                        </div>
                                        <div class="col-md-2">
                                          <span style={{ fontSize: "14px" }}>
                                            {
                                              relatedList[0]?.date?.split(
                                                "T",
                                              )[0]
                                            }
                                          </span>
                                        </div>
                                        <div class="col-md-2">
                                          <span style={{ fontSize: "14px" }}>
                                            {relatedList[0]?.toAcc?.amount}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            ))}
                        </>
                      )}

                      {showFilterBC && (
                        <>
                          {filterBankCashList
                            .slice(0)
                            .reverse()
                            .map((e, i) => (
                              <tbody key={e._id}>
                                <tr>
                                  <td>{++i}</td>
                                  <td>{e.date ? e.date.split("T")[0] : ""}</td>

                                  <td>{e.fromAcc?.name}</td>
                                  <td>{e.toAcc?.name}</td>
                                  <td>{e.remark ? e.remark : ""}</td>
                                  <td>{e.amount ? e.amount : ""}</td>
                                  <td className="text-center">
                                    <button
                                      class="btn btn-primary btn-sm"
                                      onClick={() => handleRelated(e._id)}
                                    >
                                      View{" "}
                                    </button>
                                  </td>
                                </tr>

                                <tr
                                  className="bg-gradient-light"
                                  id={"toggle" + e._id}
                                  hidden
                                >
                                  <td colspan="12">
                                    <div>
                                      <div class="row">
                                        <div class="col-md-2">
                                          <label
                                            style={{ fontSize: "15px" }}
                                            class="text-dark"
                                          >
                                            No
                                          </label>
                                        </div>
                                        <div class="col-md-3">
                                          <label
                                            style={{ fontSize: "15px" }}
                                            class="text-dark"
                                          >
                                            Account
                                          </label>
                                        </div>
                                        <div class="col-md-2">
                                          <label
                                            style={{ fontSize: "15px" }}
                                            class="text-dark"
                                          >
                                            Type
                                          </label>
                                        </div>
                                        <div class="col-md-2">
                                          <label
                                            style={{ fontSize: "15px" }}
                                            class="text-dark"
                                          >
                                            Date
                                          </label>
                                        </div>
                                        <div class="col-md-2">
                                          <label
                                            style={{ fontSize: "15px" }}
                                            class="text-dark"
                                          >
                                            Amount
                                          </label>
                                        </div>
                                      </div>
                                      <div className="row">
                                        <div class="col-md-2">
                                          <span style={{ fontSize: "14px" }}>
                                            1
                                          </span>
                                        </div>
                                        <div class="col-md-3">
                                          <span style={{ fontSize: "14px" }}>
                                            {relatedList[0]?.fromAcc?.name}
                                          </span>
                                        </div>
                                        <div class="col-md-2">
                                          <span style={{ fontSize: "14px" }}>
                                            {
                                              relatedList[0]?.fromAcc
                                                ?.accountNature
                                            }
                                          </span>
                                        </div>
                                        <div class="col-md-2">
                                          <span style={{ fontSize: "14px" }}>
                                            {
                                              relatedList[0]?.date?.split(
                                                "T",
                                              )[0]
                                            }
                                          </span>
                                        </div>
                                        <div class="col-md-2">
                                          <span style={{ fontSize: "14px" }}>
                                            {relatedList[0]?.fromAcc?.amount}
                                          </span>
                                        </div>
                                      </div>
                                      <div className="row">
                                        <div class="col-md-2">
                                          <span style={{ fontSize: "14px" }}>
                                            2
                                          </span>
                                        </div>
                                        <div class="col-md-3">
                                          <span style={{ fontSize: "14px" }}>
                                            {relatedList[0]?.toAcc?.name}
                                          </span>
                                        </div>
                                        <div class="col-md-2">
                                          <span style={{ fontSize: "14px" }}>
                                            {
                                              relatedList[0]?.toAcc
                                                ?.accountNature
                                            }
                                          </span>
                                        </div>
                                        <div class="col-md-2">
                                          <span style={{ fontSize: "14px" }}>
                                            {
                                              relatedList[0]?.date?.split(
                                                "T",
                                              )[0]
                                            }
                                          </span>
                                        </div>
                                        <div class="col-md-2">
                                          <span style={{ fontSize: "14px" }}>
                                            {relatedList[0]?.toAcc?.amount}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            ))}
                        </>
                      )}
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <TransferModal
            open={open}
            close={() => setOpen(false)}
            setOpen={setOpen}
            bankList={bankList}
            cashList={cashList}
            setTransferList={setTransferList}
            transferList={transferList}
          />
          {/* <MedicineSaleDialog
            open={open}
            close={() => setOpen(false)}
            setOpen={setOpen}
            grand={grand}
          /> */}
        </div>

    </>
  );
}
